const DEVICE_KEY = "cg_device_id";

// getDeviceId 返回稳定设备标识（匿名上报用），不存在则生成并持久化。
export function getDeviceId(): string {
	if (typeof window === "undefined") return "";
	let id = localStorage.getItem(DEVICE_KEY);
	if (!id) {
		id =
			crypto.randomUUID?.() ??
			`d_${Date.now()}_${Math.random().toString(16).slice(2)}`;
		localStorage.setItem(DEVICE_KEY, id);
	}
	return id;
}
